<div class="quotes-page">
  <header class="quotes-header">
    <h1>Tennis quotes</h1>
    <p class="subhead">Wisdom from players and coaches</p>
  </header>

  <div *ngIf="loading" class="state">Loading quotes…</div>
  <div *ngIf="!loading && error" class="state error">{{ error }}</div>

  <ul *ngIf="!loading && !error" class="quote-list">
    <li *ngFor="let q of quotes" class="quote-card">
      <blockquote class="quote-text">“{{ q.quote }}”</blockquote>
      <footer class="quote-author">— {{ q.author }}</footer>
    </li>
  </ul>

  <p *ngIf="!loading && !error && quotes.length === 0" class="state">No quotes in the database yet.</p>
</div>
